/*
  Fills the quick view's "Shop more like this" strip from Shopify's Product
  Recommendations API.

  A MutationObserver is used rather than an inline script because the quick view
  injects its markup with innerHTML, and innerHTML does not execute <script>
  tags. The theme's own quickview code exposes no "content injected" event we can
  rely on either — theme:quickview:media only fires when the product has media.

  Fails silently: on any error the placeholder stays :empty, which CSS hides, so
  the modal is never left with a broken or half-rendered section.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-qv-recommendations]';

  function fill(el) {
    // The observer can see the same node more than once; only fetch once per element.
    if (el.dataset.qvLoaded) return;
    el.dataset.qvLoaded = '1';

    var url = el.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = document.createElement('div');
        parsed.innerHTML = html;

        // Section endpoints wrap output in <div id="shopify-section-…" class="shopify-section">
        var section = parsed.querySelector('.shopify-section') || parsed.firstElementChild;

        /*
          Pregnancy / breastfeeding rule: the endpoint can't see which product
          opened the quick view, so api-product-quickview.liquid flags the
          placeholder and the recommendations markup flags the cards to drop.
        */
        if (section && el.dataset.qvSensitive === '1') {
          Array.prototype.forEach.call(section.querySelectorAll('[data-rec-avoid]'), function (card) {
            card.parentNode.removeChild(card);
          });
          if (!section.querySelector('.qv__card')) section = null;
        }

        var content = section ? section.innerHTML.trim() : '';

        if (content) el.innerHTML = content;
      })
      .catch(function () {
        /* Leave the placeholder empty — CSS keeps it hidden. */
      });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches && node.matches(SELECTOR)) fill(node);
    if (node.querySelectorAll) {
      Array.prototype.forEach.call(node.querySelectorAll(SELECTOR), fill);
    }
  }

  function start() {
    scan(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, scan);
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
